/* eslint-disable react-hooks/exhaustive-deps */
import { SxProps, Theme } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { AutoCompleteTargetString } from '../Types/autocomplete.target';
import GnlModulDTO from 'src/models/Settings/Generals/GnlModulDTO';
import { TextField } from 'src/components';
import { AutocompleteChangeDetails, AutocompleteChangeReason, AutocompleteOwnerState, AutocompleteRenderInputParams, AutocompleteRenderOptionState, FilterOptionsState } from '@mui/material';
import { helper } from 'src/utils/helper';
import { useModulListesiQuery } from 'src/services/Settings/Generals/ModulTanimApi';
import Autocomplete from 'src/components/Autocomplete';
import { useGetVwKullaniciMenuyetkiQuery } from 'src/services/Auth/KullaniciRolYetkiApi';
import { useAppSelector } from 'src/store';

interface IModulMultiAutocompleteProps {
    yetkiBazliGetir?: boolean;
    value?: string;
    disableClearable?: boolean;
    sx?: SxProps<Theme>;
    name?: string;
    label?: string;
    error?: boolean;
    children?: React.ReactNode;
    id?: string;
    required?: boolean;
    onChange?: (e: AutoCompleteTargetString) => void;
    helperText?: string;
    readonly?: boolean;
    limitTags?: number;
};

const ModulMultiAutocomplete = (props: IModulMultiAutocompleteProps): JSX.Element => {
    const userInfo = useAppSelector(s => s.userLogin.userInfo);
    const organizasyon = useAppSelector(s => s.userOrganizasyon.organizasyon);
    const query = useModulListesiQuery();
    const menuAuthQuery = useGetVwKullaniciMenuyetkiQuery(userInfo?.id, { skip: !organizasyon.fkOrganizasyon });

    const [options, setOptions] = useState<Array<GnlModulDTO>>(new Array<GnlModulDTO>());
    const [values, setValues] = useState<Array<GnlModulDTO>>(new Array<GnlModulDTO>());

    useEffect(() => {
        if (!query.isFetching && !menuAuthQuery.isFetching) {
            if (props.yetkiBazliGetir) {
                const modulYetkiIds = Array.from(new Set(menuAuthQuery.data?.map((m) => m.fkGnlModulId)));
                setOptions(query.data.filter((f) => modulYetkiIds.includes(f.pkModulid)));
                return;
            }
            setOptions(query.data);
        }
    }, [query.isFetching, menuAuthQuery.isFetching]);

    useEffect(() => {
        if (props?.value && query.data?.length > 0) {
            const selectedIds = props?.value?.split(",").map(Number) || [];
            const val = options?.filter((f) => selectedIds.includes(f.pkModulid));
            setValues(val);
        }
        else
            setValues([]);
    }, [props.value, options]);

    const filterOptions = (options: GnlModulDTO[], state: FilterOptionsState<GnlModulDTO>): GnlModulDTO[] => {
        return options?.filter(f => helper.UpperCaseAsc(f.moduladi).indexOf(helper.UpperCaseAsc(state.inputValue)) > -1)
    };
    const getOptionLabel = (option: GnlModulDTO): string => {
        if (!option.moduladi)
            return "";
        return option.moduladi;
    };
    const renderOption = (props, option: GnlModulDTO, state: AutocompleteRenderOptionState, ownerState: AutocompleteOwnerState<GnlModulDTO, false, boolean, false, "div">): React.ReactNode => {
        if (!option?.moduladi)
            return "";
        return (
            <li {...props} key={option.moduladi}>
                {option.moduladi}
            </li>
        );
    };
    const onChange = (event: React.SyntheticEvent<Element, Event>, value: GnlModulDTO[], reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<GnlModulDTO>): void => {
        const val = value ? value.map(m => m.pkModulid).join(",") : "";
        props.onChange?.({ target: { value: val, name: props.name } });
        setValues(value);
    };
    const renderInput = (params: AutocompleteRenderInputParams): React.ReactNode => {
        return (
            <TextField
                {...params}
                multiline
                required={props.required}
                label={props.label}
                error={props.error || Boolean(props.error)}
                helperText={props.helperText}
            />
        );
    };
    return (
        <Autocomplete
            fullWidth
            readOnly={props.readonly}
            freeSolo={false}
            multiple
            sx={props.sx}
            id={props.id}
            disableClearable={props.disableClearable}
            options={options ? options : []}
            value={values?.length > 0 ? values : []}
            limitTags={props.limitTags}
            isOptionEqualToValue={(o, s) => o?.pkModulid === s?.pkModulid}
            filterOptions={filterOptions}
            getOptionLabel={getOptionLabel}
            renderOption={renderOption}
            onChange={onChange}
            renderInput={renderInput}
        />
    );
};

export default ModulMultiAutocomplete;